import { render } from "./LyricsFallingInLove.vue?vue&type=template&id=401dd995&scoped=true"
import script from "./LyricsFallingInLove.vue?vue&type=script&lang=js"
export * from "./LyricsFallingInLove.vue?vue&type=script&lang=js"

import "./LyricsFallingInLove.vue?vue&type=style&index=0&id=401dd995&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401dd995"]])

export default __exports__